export default "__VITE_ASSET__DwuOxQlc__"